import { BaseRoutes } from './base.routes.constants';

export class UnidadeRoutes extends BaseRoutes {
  constructor(route: string) {
    super(route);
  }
}
